export default "__VITE_ASSET__ZKhtwPoX__"